import { Subscription } from 'rxjs';
import { EscalaService } from './../../../../services/operacao/escala.service';
import { ReportUtil } from './../util/reports.util';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/vos/auth.service';

@Component({
  selector: 'app-modal-view-report',
  templateUrl: './modal-view-report.component.html',
  styleUrls: ['./modal-view-report.component.css']
})
export class ModalViewReportComponent implements OnInit {

  user: any = [];
  loadingServiceDate: boolean;
  days: any[];
  title: string;

  inscricao: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalViewReportComponent>,
    private authService: AuthService,
    public reportUtil: ReportUtil,
    private escalaService: EscalaService,
  ) { }

  ngOnInit(): void {
    this.title = 'Relatório Mensal - ' + this.data?.mes + '/' + this.data?.ano;
    this.getUser();
    this.filterScales();
  }

  getUser() {
    this.user = JSON.parse(this.authService.getUserLoggedIn());
  }

  // get isNotProfessionalForHH() {
  //   return this.user.user.pessoa.profissional.empresa_id != 42;
  // }

  closeDialog() {
    this.dialogRef.close();
  }

  filterScales() {
    this.loadingServiceDate = true;
    let array = {
      paciente_id: this.data.patient_id,
      ordemservico_id: this.data.ordemservico_id,
      contract_id: this.data.contract_id,
      month: this.data.mes,
      year: this.data.ano,
      servico_id: this.data.servico_id
    };
    this.inscricao = this.escalaService.getDaysOfScale(array).subscribe({
      next: res => {
        this.days = res;
        this.loadingServiceDate = false;
      },
      error: er => {
        this.loadingServiceDate = false;
      }
    })
  }
}
